export function customToLowerCase(s: string): string {
  return s
    .split(" ")
    .map((word) =>
      word === "OR" || word === "AND" ? word : word.toLowerCase()
    )
    .join(" ");
}
